import { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

/**
 * Componente que maneja:
 * - Aviso de modo offline / online
 *
 * La invitación a instalar la app se retiró: este componente se monta en toda
 * la aplicación, incluido el menú público, así que el cliente que entraba
 * desde el celular a ver la carta recibía una oferta de instalar el sistema
 * de gestión del restaurante.
 */
export default function PWAStatus() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showOnlineToast, setShowOnlineToast] = useState(false);

  useEffect(() => {
    // Se sigue escuchando el evento SOLO para cancelarlo: `preventDefault`
    // impide que Chrome muestre su propia barra de "Instalar aplicación".
    // Si se quitara el listener, volvería a aparecer la del navegador.
    const handler = (e) => e.preventDefault();
    window.addEventListener('beforeinstallprompt', handler);

    // Escuchar cambios de conexión
    const handleOnline = () => {
      setIsOffline(false);
      setShowOnlineToast(true);
      setTimeout(() => setShowOnlineToast(false), 3000);
    };
    const handleOffline = () => {
      setIsOffline(true);
      setShowOnlineToast(false);
    };
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {/* Indicador permanente de offline */}
      {isOffline && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white text-xs sm:text-sm font-medium py-1.5 px-4 flex items-center justify-center gap-2 shadow-md">
          <WifiOff className="w-4 h-4" />
          <span>Sin conexión — los cambios se guardarán localmente y se sincronizarán al volver</span>
        </div>
      )}

      {/* Toast cuando vuelve la conexión */}
      {showOnlineToast && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 bg-green-500 text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg flex items-center gap-2 animate-in fade-in">
          <Wifi className="w-4 h-4" />
          Conexión restaurada
        </div>
      )}
    </>
  );
}
